export const HOSTING_TYPE_LABELS = {
    AzureWebApp: "Azure Web App",
    DockerContainer: "Docker-container",
    VirtualMachine: "Virtuell maskin",
    Other: "Övrigt",
};
export const SYSTEM_TYPE_LABELS = {
    Website: "Webbplats",
    Api: "API",
    Other: "Övrigt",
};
export function formatRelativeTime(iso) {
    if (!iso)
        return "Aldrig kontrollerad";
    const diffMs = Date.now() - new Date(iso).getTime();
    const diffSec = Math.round(diffMs / 1000);
    if (diffSec < 60)
        return `${diffSec}s sedan`;
    const diffMin = Math.round(diffSec / 60);
    if (diffMin < 60)
        return `${diffMin} min sedan`;
    const diffHour = Math.round(diffMin / 60);
    if (diffHour < 24)
        return `${diffHour} tim sedan`;
    const diffDay = Math.round(diffHour / 24);
    return `${diffDay} dygn sedan`;
}
